module.exports = __webpack_public_path__ + "img/contacts.e311c02.jpg";